window.isLoopActive = () => {
  try { return !!window.LoopOnstore?.isActive?.(); } catch (e) { return false; }
};

if (!window.debounce) {
  window.debounce = (callback, wait) => {
    let timeoutId = null;
    return (...args) => {
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => {
      callback.apply(null, args);
      }, wait);
    };
  }
}

function uuidv4() {
  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}

// Focus trapping for ADA
window.addEventListener('load', () => {
  [...document.querySelectorAll('[role="dialog"]')].forEach(dialog => trapFocusInDialog(dialog));
});

function trapFocusInDialog(dialog) {
  const keyboardfocusableElements = dialog.querySelectorAll('a[href]:not(.hidden a[href]), button:not(.hidden button), input:not(.hidden input), textarea:not(.hidden textarea), select:not(.hidden select), details:not(.hidden details), [tabindex]:not([tabindex="-1"]):not(.hidden [tabindex]:not([tabindex="-1"]))');
  const firstFocusableElement = keyboardfocusableElements[0];
  const lastFocusableElement = keyboardfocusableElements[keyboardfocusableElements.length - 1];

  dialog.addEventListener('keydown', function(e) {
    if (e.target == firstFocusableElement && e.key == 'Tab' && e.shiftKey) {
      e.preventDefault();
      lastFocusableElement.focus();
    } else if(e.target == lastFocusableElement && e.key == 'Tab' && !e.shiftKey) {
      e.preventDefault();
      firstFocusableElement.focus();
    }
  });      
}

// Sticky scroll-up header
let curScroll;
let prevScroll = window.scrollY || document.documentElement.scrollTop;
let curDirection = 0;
let prevDirection = 0;
let lastY = 0;
let header = document.querySelector('[data-top-menu]');
let toggled;
let downThreshold = 0; //--keeps header visible till user scrolls down (x) pixels
let upThreshold = 50; //--keeps header hidden till user scrolls up (x) pixels
// let useDynamicBadge;
// let showSaleBadge;
// let useVariantMenu;

checkScroll = () => {
  curScroll = window.scrollY || document.documentElement.scrollTop;
  curDirection = curScroll > prevScroll ? 2 : 1;
  curDirection !== prevDirection ? toggled = toggleHeader() : lastY = curScroll;
  prevScroll = curScroll;
  if (toggled) {
    prevDirection = curDirection;
  }
};

toggleHeader = () => { 
  toggled = true;
  if (curDirection === 2 && (curScroll-lastY) > downThreshold) {
    lastY = curScroll
    header.classList.add('lg:-translate-y-[34px]');
  }
  else if (curDirection === 1 && (lastY-curScroll) > upThreshold) {
    lastY=curScroll
    header.classList.remove('lg:-translate-y-[34px]');
  }
  else {
    toggled = false;
  }
  return toggled;
};

window.addEventListener('scroll', checkScroll);

if (document.body.dataset.showSticky === 'true') {
	let desktopObserver = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			let isAbove = window.scrollY < document.querySelector('[data-observe-atc]').offsetTop;
			desktopButtonVisibility(entry.isIntersecting || isAbove);
		});
	}, { threshold: 1 });

	let target = document.querySelector('[data-observe-atc]');
	if (target) desktopObserver.observe(target);
}

setInterval(() => { //AB TEST INTERVAL
	if (document.body.dataset.showSticky === 'true') { //AB TEST IF WRAPPER
		let target = document.querySelector('[data-observe-atc]');
		if (!target || window.desktopObserver) return;

		window.desktopObserver = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				let isAbove = window.scrollY < target.offsetTop;
				desktopButtonVisibility(entry.isIntersecting || isAbove);
			});
		}, { threshold: 1 });

		window.desktopObserver.observe(target);
	}
}, 2000);



function desktopButtonVisibility(isVisible) {
  document.querySelector('[data-hide-atc-desktop]')?.classList.toggle('hidden', isVisible);
}

function scrollToTitle() {
  const stickyATC = document.querySelector('[data-atc-scroll-desktop]');
  const productTitle = document.querySelector('coco-shuffle');

  if (stickyATC && stickyATC.hasAttribute('data-atc-ready')) {
    const atcButton = productTitle?.querySelector('[data-action="add-to-cart"]');
    if (atcButton) {
      stickyATC.disabled = true;
      window.addEventListener('addToCartDidSubmit', () => {
        stickyATC.disabled = false;
      }, { once: true });
      atcButton.click();
      return;
    }
  }

  if (stickyATC && stickyATC.hasAttribute('data-atc-notify')) {
    const notifyButton = productTitle?.querySelector('[data-notify-me]');
    if (notifyButton) {
      notifyButton.click();
      return;
    }
  }

  if (productTitle) {
    productTitle.classList.add('selection-needed');

    const scrollTarget = productTitle.querySelector('[data-display-options]') ?? productTitle;
    const headerActionsEl = document.querySelector('[data-header-actions]');
    let searchBarHeight = document.querySelector('[data-mobile-search]')?.offsetHeight ?? 0;
    let headerBottom = headerActionsEl?.getBoundingClientRect().bottom ?? header?.getBoundingClientRect().bottom ?? 124;
    let headerOffset = searchBarHeight + headerBottom;
    let titlePosition = scrollTarget.getBoundingClientRect().top;
    let offsetPosition = titlePosition + window.pageYOffset - headerOffset;

    window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
    });

    gtag('event', 'sticky_ATC_click', {
      event_category: 'experiments',
      event_action: 'stickyATC',
      value: 1
    });
  }
}

document
  .querySelectorAll(
    '[data-atc-scroll-desktop], [data-sticky-atc-size-wrapper], [data-sticky-atc-swatch]'
  )
  .forEach(el => {
    el.addEventListener('click', scrollToTitle);
  });

function poll(fn, timeout, interval) {
  var endTime = Number(new Date()) + (timeout || 2000);
  interval = interval || 100;

  var checkCondition = function(resolve, reject) {
    var result = fn();
    if(result) {
      resolve(result);
    }
    else if (Number(new Date()) < endTime) {
      setTimeout(checkCondition, interval, resolve, reject);
    }
    else {
      reject(new Error('timed out for ' + fn + ': ' + arguments));
    }
  };

  return new Promise(checkCondition);
}

// FAST SIMON SSR SHADOWROOT STYLE INJECTION
poll(() => {
  return document.getElementById('serp-portal')?.shadowRoot;
}, 10000, 150).then(() => {
  const FastSimonAppWrapper = document.getElementById('serp-portal');
  if (!FastSimonAppWrapper) return;
  
  let link = document.createElement('link');
  let tailwind = document.createElement('link');
  link.setAttribute('rel', 'stylesheet');
  tailwind.setAttribute('rel', 'stylesheet');

  let pr_script = document.createElement('script');
  pr_script.setAttribute('type', 'text/javascript');
  pr_script.src ='https://ui.powerreviews.com/stable/4.1/ui.js';

  

  if (window.location.href.includes(`127.0`)) {

    link.setAttribute('href', `/assets/fast-simon-overrides.css`);
    tailwind.setAttribute('href', `/assets/tailwind.css`);
  } else {
    link.setAttribute('href', `//winkscrubs.com/cdn/shop/t/1143/assets/fast-simon-overrides.css?v=148541653819938529971787005679`);
    tailwind.setAttribute('href', "//winkscrubs.com/cdn/shop/t/1143/assets/tailwind.css?v=105693800077540013481787005679");
  }
  FastSimonAppWrapper.shadowRoot.appendChild(link);
  FastSimonAppWrapper.shadowRoot.appendChild(pr_script);
  FastSimonAppWrapper.shadowRoot.appendChild(tailwind);
}).catch(() => {
  console.error('No Fast Simon App Found')
});
poll(() => {
  return document.getElementById('fast-simon-serp-app')?.shadowRoot;
}, 10000, 150).then(() => {
  const FastSimonAppWrapper = document.getElementById('fast-simon-serp-app');
  if (!FastSimonAppWrapper) return;
  
  let link = document.createElement('link');
  let tailwind = document.createElement('link');
  link.setAttribute('rel', 'stylesheet');
  tailwind.setAttribute('rel', 'stylesheet');

  if (window.location.href.includes(`127.0`)) {
    link.setAttribute('href', `/assets/fast-simon-overrides.css`);
    tailwind.setAttribute('href', `/assets/tailwind.css`);
  } else {
    link.setAttribute('href', `//winkscrubs.com/cdn/shop/t/1143/assets/fast-simon-overrides.css?v=148541653819938529971787005679`);
    tailwind.setAttribute('href', "//winkscrubs.com/cdn/shop/t/1143/assets/tailwind.css?v=105693800077540013481787005679");
  }
  FastSimonAppWrapper.shadowRoot.appendChild(link);
  FastSimonAppWrapper.shadowRoot.appendChild(tailwind);
}).catch(() => {
  console.error('No Fast Simon App Found')
});

const showProp65Messages = (() => {
  const visitor_location = JSON.parse(sessionStorage.getItem('visitor_location'));
  const prop_65_containers = document.querySelectorAll('[data-prop-65]');
  
  if (visitor_location && visitor_location.state_prov !== 'California') {
    prop_65_containers.forEach((container) => {
      container.classList.add('hidden');
    });
    return;
  }

  prop_65_containers.forEach((container) => {
    container.classList.remove('hidden');
  })
});

const fetchLocation = (async () => {
  let url = 'https://api.ipgeolocation.io/ipgeo';
  try {
    const response = await fetch(url);
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching location:', error);
  }
});

const setLocationCookie = ((result) => {
  const obj = {
    continentCode: result.continent_code,
    countryCode: result.country_code2,
    state_prov: result.state_prov,
    expiresAt: new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 2)).getTime(),
  }
  sessionStorage.setItem('visitor_location', JSON.stringify(obj));
  showProp65Messages(); 
});


window.addEventListener('load', () => {  
  const visitorLocation = sessionStorage.getItem('visitor_location');
  if (visitorLocation) {
    const obj = JSON.parse(visitorLocation);
    if (new Date() > new Date(obj.expiresAt)) {
      fetchLocation()
        .then(result => {
          setLocationCookie(result)
        })
        .catch(error => {
          console.error('Error:', error);
        });
    } else {
      showProp65Messages();
    }
  } else {
    fetchLocation()
      .then(result => {
        setLocationCookie(result)
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }
});